import React, { useEffect, useState } from 'react';
import { MdsButton, MdsRadioGroup } from "@mds/react";
import "./choose-target-stylesheet.scss";
import EmailFeatured from "@mds/web-illustrations/dist/cmb/svgs/mds_ill_email_featured.svg";

interface PossibleTargetType {
  _channel: number;
  _channelAssertionId: string;
  _channelIndex: number;
  _description: string;
  _deviceDetails: unknown;
  _targetIdentifier: string;
}

const getTargetData = () => {
  const arr = sessionStorage.getItem("targetData") ?? "[]";
  return JSON.parse(arr) as PossibleTargetType[];
};

const ChooseTarget = () => {
  const [targetData, setTargetData] = useState(getTargetData());
  const [selectedEmailIndex, setSelectedEmailIndex] = useState(0);
  const selectedEmail = targetData[selectedEmailIndex];
  const isMultipleEmail = targetData.length > 1;
  const radioButtonGroup = targetData.map((singleTarget) => {
    const mungedLabel = singleTarget._description;
    return {
      label: mungedLabel,
      value: singleTarget,
    };
  });

  useEffect(() => {
    /*
      addsEventLisener and waits for "storage" event fired in otp.js => promiseTargetSelectionInput()
    */
    const storage = (_event: Event) => {
      const data = getTargetData();
      if (data) setTargetData(data);
    };
    window.addEventListener("storage", storage);

    return () => {
      // cleanup function removing session storage and eventListener
      window.removeEventListener("storage", storage);
      sessionStorage.clear();
    };
  }, []);

  const handleRadioChange = (selectedIndex: number) => {
    setSelectedEmailIndex(selectedIndex);
  };

  return (
    <>
      {/* DIV element to return selectedEmailIndex back to transmit */}
      <div id="selected-target-index" className="hidden">
        {selectedEmailIndex}
      </div>
      <div id="email-cta">
        <div className="back-button-mobile-wrapper">
          <MdsButton
            text="Back"
            iconAccessibleDescription=""
            id="mb-ct-back-button"
            iconType="ico_chevron_left"
            iconPosition="leading"
            variant="tertiary"
          />
        </div>
        <h2 id="email-cta-greeting" className="title-xlarge">
          Sign in to <span>the dashboard</span>
        </h2>
        <p id="where-should-we-send" className="body-large">
          {isMultipleEmail
            ? "Where should we send your one-time code?"
            : "We'll send your one-time code to the email on file"}
        </p>
        <form id="partner-portal-confirm-email">
          <div className="emails">
            <img id="featured-email-graphic" alt="" src={EmailFeatured} />
            {targetData.length ? (
              <>
                {isMultipleEmail ? (
                  <MdsRadioGroup
                    radioButtons={radioButtonGroup}
                    name="email-radio"
                    onChange={(e) => handleRadioChange(e.target.selectedIndex)}
                    selectedIndex={selectedEmailIndex}
                  />
                ) : (
                  <p className="single-selected-email body-large">
                    {selectedEmail._description}
                  </p>
                )}
              </>
            ) : null}
          </div>
          <div className="send-code-btn-wrapper">
            <MdsButton
              id="send-otp"
              text="Send code"
              variant="primary"
              widthType="layout"
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default ChooseTarget;
